import React from 'react';
import style from './style.module.scss';

interface PageCardProps {
  children: React.ReactNode;
}

export const PageCard: React.FC<PageCardProps> = (props) => {
  return <div className={style.pageCard}>
    {props.children}
  </div>
}
